import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface MegaMenuOverlayProps {
  children: React.ReactNode;
}

const MegaMenuOverlay: React.FC<MegaMenuOverlayProps> = (props) => {
  const { children } = props;

  const innerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | 'auto'>('auto');

  useEffect(() => {
    if (!innerRef.current) {
      return () => {};
    }

    const resizeObserver = new ResizeObserver((entries) => {
      // We only have one entry, so we can use entries[0].
      const observedHeight = entries[0]?.borderBoxSize[0]?.blockSize || 0;

      setHeight(observedHeight);
    });

    resizeObserver.observe(innerRef.current);

    return () => {
      // Cleanup the observer when the component is unmounted
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <motion.div
        style={{ height }}
        animate={{ height }}
        className="MegaMenu__Overlay"
      >
        <Container className="root-container">
          <div className="row">
            <div className="col-12">
              <div className="MegaMenu__Overlay__inner" ref={innerRef}>
                {children}
              </div>
            </div>
          </div>
        </Container>
      </motion.div>
      <div className="MegaMenu__Overlay__backdrop" />
    </>
  );
};

export default MegaMenuOverlay;
